import SurveyResponsesMonthlyTable from './SurveyResponsesMonthlyTable';

export default SurveyResponsesMonthlyTable;
